import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Package } from "lucide-react";

export const Orders = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="container mx-auto px-4 py-12 text-center">
          <p className="text-muted-foreground mb-4">Please log in to view your orders</p>
          <Button onClick={() => navigate("/login")}>Go to Login</Button>
        </div>
      </div>
    );
  }

  const sampleOrders = [
    {
      id: "ORD-12345678",
      date: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toLocaleDateString(),
      total: 299.99,
      status: "Delivered",
      items: 3,
    },
    {
      id: "ORD-12345679",
      date: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000).toLocaleDateString(),
      total: 149.99,
      status: "Delivered",
      items: 2,
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <div className="container mx-auto max-w-4xl px-4 py-12">
        <h1 className="text-3xl font-bold mb-8">My Orders</h1>

        {sampleOrders.length === 0 ? (
          <div className="text-center py-12">
            <Package className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground mb-6">No orders yet</p>
            <Button onClick={() => navigate("/")}>Start Shopping</Button>
          </div>
        ) : (
          <div className="space-y-4">
            {sampleOrders.map((order) => (
              <div
                key={order.id}
                className="bg-muted rounded-lg p-6 border border-border flex items-center justify-between"
              >
                <div>
                  <p className="font-bold text-lg">{order.id}</p>
                  <p className="text-muted-foreground text-sm">{order.date}</p>
                  <p className="text-sm mt-2">{order.items} items</p>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-primary">
                    ${order.total.toFixed(2)}
                  </p>
                  <span className="inline-block mt-2 px-3 py-1 rounded-full bg-green-100 text-green-800 text-xs font-semibold">
                    {order.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}

        <Button
          variant="outline"
          className="w-full mt-8"
          onClick={() => navigate("/")}
        >
          Continue Shopping
        </Button>
      </div>
    </div>
  );
};
